/**
 * Máscaras puras para inputs React (onChange + value).
 * Substitui a biblioteca Inputmask que crashava com scripts externos
 * (autofill, extensões, gerenciadores de senha).
 */

const MASKS = {
  // (99) 9 9999-9999 — Celular brasileiro
  phone: {
    format: (value: string) => {
      const d = value.replace(/\D/g, '').slice(0, 11);
      if (d.length === 0) return '';
      if (d.length <= 2) return `(${d}`;
      if (d.length <= 3) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
      if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2, 3)} ${d.slice(3)}`;
      return `(${d.slice(0, 2)}) ${d.slice(2, 3)} ${d.slice(3, 7)}-${d.slice(7)}`;
    },
    maxLength: 16,
    inputMode: 'tel' as const,
  },

  // 9999 9999 9999 9999 — Número do cartão
  card: {
    format: (value: string) => {
      const d = value.replace(/\D/g, '').slice(0, 16);
      const groups = d.match(/.{1,4}/g);
      return groups ? groups.join(' ') : '';
    },
    maxLength: 19,
    inputMode: 'numeric' as const,
  },

  // 999.999.999-99 — CPF
  cpf: {
    format: (value: string) => {
      const d = value.replace(/\D/g, '').slice(0, 11);
      if (d.length <= 3) return d;
      if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
      if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
      return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
    },
    maxLength: 14,
    inputMode: 'numeric' as const,
  },

  // 999 ou 9999 — CVV
  cvv: {
    format: (value: string) => value.replace(/\D/g, '').slice(0, 4),
    maxLength: 4,
    inputMode: 'numeric' as const,
  },

  // 99/9999 — Validade MM/AAAA
  validity: {
    format: (value: string) => {
      const d = value.replace(/\D/g, '').slice(0, 6);
      if (d.length <= 2) return d;
      return `${d.slice(0, 2)}/${d.slice(2)}`;
    },
    maxLength: 7,
    inputMode: 'numeric' as const,
  },
};

export type MaskName = keyof typeof MASKS;

export function applyMask(value: string, maskName: MaskName): string {
  return MASKS[maskName].format(value);
}

export function getMaskProps(maskName: MaskName) {
  const mask = MASKS[maskName];
  return { inputMode: mask.inputMode, maxLength: mask.maxLength };
}
